import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom.min";
import "../../assets/styles/local/AddToWareHouseProject.css";
import WarehouseIcon from "../../assets/icons/Warehouse.svg";
import DownArrow from "../../assets/icons/downarrow.svg";
import searchIcon from "../../assets/icons/search.svg";
import PlusIcon from "../../assets/images/Plus.svg";
import Pagination from "../../components/Pagination/Pagination";
import Header from "../../layouts/Header";
import { FetchWarehousePurchasingOrder } from "../../redux/actions/action";
import useScreenSize from "../../utils/hooks/useScreenSizeHook";
import smallIcon from "..//../assets/icons/meh.svg";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const AddToWareHouseProject = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [query, setQuery] = useState("");
  const [perPage, setPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [tableData, setTableData] = useState([]);
  const fetchWarehouseData = useSelector(
    (state) => state.user.fetchWarehousePurchasingOrder,
  );
  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  const myAppName = localStorage.getItem("myAppName");
  const isOrderPicking = myAppName === "orderpicking";

  const screenSize = useScreenSize();

  useEffect(() => {
    dispatch(FetchWarehousePurchasingOrder(perPage, currentPage + 1, query));
  }, [currentPage, dispatch, query]);

  useEffect(() => {
    setCurrentPage(0);
  }, [query, perPage]);

  useEffect(() => {
    if (fetchWarehouseData != null && fetchWarehouseData?.status) {
      const totalRecords = fetchWarehouseData?.totalCount;
      const newTotalPages = Math.ceil(totalRecords / perPage);
      setTotalPages(newTotalPages);
      setTableData(fetchWarehouseData?.data);
    }
  }, [fetchWarehouseData, query]);

  useEffect(() => {
    fetchScreenTranslations("Add To Warehouse And Assign To Project").then(
      (data) => setFetchTranslationList(data),
    );
  }, []);

  return (
    <>
      <Header
        leftComponent={
          <div className="stock-heading-box">
            <div
              className="stock-heading cursor-pointer"
              onClick={() => {
                history.push("/stock");
              }}
            >
              {/* Stock */}
              {t("Stock")}
            </div>
            <div className="box-title">
              {/* Add to Warehouse and assign to project */}
              {t("Add to Warehouse and assign to project")}
            </div>
          </div>
        }
        setQuery={setQuery}
      />
      {screenSize === "xs" || isOrderPicking ? (
        <div className="container-fluid add-to-warehouse-main-wrapper">
          <div className="main-wrapper add-to-warehouse-wrapper">
            <div
              style={{
                display: "flex",
                // gap: "10px",
                // justifyContent: "space-between",
              }}
            >
              <div
                onClick={() => {
                  history.push("/stock");
                }}
                style={{ display: "flex", gap: "1px" }}
              >
                <div
                  style={{
                    color: "#7F7E7F",
                    fontWeight: "bolder",
                    fontSize: "1.1rem",
                    marginTop: "10px",
                    marginBottom: "15px",
                  }}
                >
                  {/* Stock */}
                  {t("Stock")}
                </div>
                <img
                  alt=""
                  src={DownArrow}
                  style={{
                    opacity: "60%",
                    marginTop: "18px",
                    marginBottom: "15px",
                    width: "15px",
                    height: "12px",
                    transform: "rotate(90deg)",
                    cursor: "pointer",
                  }}
                />
              </div>
              <div style={{ display: "flex", gap: "1px", marginRight: "0px" }}>
                <img
                  alt=""
                  src={WarehouseIcon}
                  className="mx-"
                  style={{
                    opacity: "60%",
                    marginTop: "11px",
                    marginBottom: "15px",
                    width: "15px",
                    height: "24px",
                    transform: "rotate(0deg)",
                    cursor: "pointer",
                  }}
                />
                <div
                  className="Add-to-warehouse-font ps-1"
                  style={{
                    color: "#7F7E7F",
                    fontWeight: "bolder",
                    fontSize: "1rem",
                    marginTop: "11px",
                    marginBottom: "15px",
                  }}
                >
                  {/* Add to Warehouse */}
                  {t("Add to warehouse")}
                </div>
              </div>
            </div>
            <div style={{ marginRight: "20px", marginTop: "20px" }}>
              <div className="choose-project-dropdown">
                <div
                  className="project-search-main-mobile"
                  style={{ marginBottom: "10px" }}
                >
                  <img className="search_pop ms-2 mb-1" src={searchIcon} />
                  <input
                    type="text"
                    value={query}
                    style={{
                      margin: "0 0 0 0.5rem",
                      fontSie: "14px",
                    }}
                    placeholder="Search"
                    className="search-style select-client-div"
                    onChange={(e) => {
                      setQuery(e.target.value);
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="table-wrapper-mobile">
              <table className="table stock-add-table mb-3">
                <tr>
                  <td
                    style={{
                      opacity: "80%",
                      fontWeight: "lighter",
                      fontSize: "1rem",
                      marginLeft: "20px",
                    }}
                  >
                    P. Order
                  </td>
                  <td
                    style={{
                      opacity: "80%",
                      fontWeight: "lighter",
                      fontSize: "1rem",
                    }}
                  >
                    {/* Supplier */}
                    {t("Supplier")}
                  </td>
                </tr>

                <tbody className="border-0">
                  {tableData?.map((item, index) => {
                    return (
                      <tr key={`tbl-row-${index}`}>
                        <td>{item?.ordercode}</td>
                        <td style={{ whiteSpace: "nowrap" }}>
                          {" "}
                          {item?.suppliername?.length > 15
                            ? item?.suppliername.slice(0, 15) + "..."
                            : item?.suppliername}
                        </td>

                        <td>
                          <Link
                            to={{
                              pathname: `/confirm-purchasing-order/${item.ordercode}`,
                              state: { orderid: item.orderid },
                            }}
                            className="d-flex align-items-center gap-3 redirect-link justify-content-center"
                          >
                            <img
                              className="plus-img"
                              src={PlusIcon}
                              alt="plus"
                            />
                            <div>
                              {/* Add */}
                              {t("Add")}
                            </div>
                          </Link>
                        </td>
                      </tr>
                    );
                  })}
                  {!tableData?.filter(
                    (items) =>
                      items?.ordercode?.toLowerCase()?.includes(query) ||
                      items?.suppliername?.toLowerCase()?.includes(query) ||
                      items?.projectCode?.toLowerCase()?.includes(query) ||
                      items?.projectname?.toLowerCase()?.includes(query),
                  ).length > 0 && (
                    <tr style={{ height: "83%" }}>
                      <div
                        className="row container mt-5 pt-5 d-flex position-relative d-none"
                        style={{ left: "15%" }}
                      >
                        <img
                          src={smallIcon}
                          alt="smali"
                          width={35}
                          height={35}
                          className="mt-5 "
                        />
                        <h6
                          className="mt-1"
                          style={{
                            fontSize: "14px",
                            fontWeight: 400,
                            textAlign: "center",
                            color: "#707070",
                          }}
                        >
                          {/* Sorry. */}
                          {t("Sorry")}.
                          <br />
                          {/* No results for your criteria. */}
                          {t("No results for your criteria.")}
                          <br />
                          {/* Try to refine your search or enter a new
                            search. */}
                          {t(
                            "Try to refine your search or enter a new search.",
                          )}
                        </h6>
                      </div>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          <div
            style={{
              position: "fixed",
              bottom: "0",
              marginBottom: "15px",
              padding: "20px",
              width: "90%",
              background: "#fafafa",
            }}
          >
            <section
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "10px",
                marginBottom: "25px",
              }}
            >
              <div style={{ display: "flex", gap: "10px" }}>
                <img
                  alt=""
                  src={DownArrow}
                  onClick={() => {
                    setCurrentPage(currentPage - 1);
                  }}
                  style={{
                    marginTop: "3px",
                    width: "18px",
                    height: "12px",
                    transform: "rotate(90deg)",
                    cursor: "pointer",
                    opacity: currentPage === 0 ? "50%" : "100%",
                    pointerEvents: currentPage === 0 ? "none" : "all",
                  }}
                />
                <p
                  style={{
                    opacity: currentPage === 0 ? "50%" : "100%",
                  }}
                  className="previous-week-text"
                >
                  {/* Previous page */}
                  {t("Previous page")}
                </p>
              </div>
              <div style={{ display: "flex", gap: "10px" }}>
                <p
                  className="present-week-text"
                  style={{
                    opacity: totalPages - 1 === currentPage ? "50%" : "100%",
                  }}
                >
                  {/* Next page */}
                  {t("Next page")}
                </p>
                <img
                  alt=""
                  src={DownArrow}
                  onClick={() => {
                    setCurrentPage(currentPage + 1);
                  }}
                  style={{
                    width: "18px",
                    marginTop: "3px",
                    height: "12px",
                    transform: "rotate(-90deg)",
                    cursor: "pointer",
                    opacity: totalPages - 1 === currentPage ? "50%" : "100%",
                    pointerEvents:
                      totalPages - 1 === currentPage ? "none" : "all",
                  }}
                />
              </div>
            </section>
          </div>
        </div>
      ) : (
        <div className="container-fluid add-to-warehouse-main-wrapper">
          <div className="main-wrapper add-to-warehouse-wrapper">
            <div className="table-wrapper">
              <table className="table stock-add-table">
                <thead>
                  <tr>
                    <th>{t("Purchase order\t")}</th>
                    <th>{t("Supplier")}</th>
                    <th>{t("Project")}</th>
                    <th></th>
                    <th></th>
                  </tr>
                </thead>
                <tbody className="border-0">
                  {tableData
                    ?.filter(
                      (items) =>
                        items?.ordercode
                          ?.toLowerCase()
                          ?.includes(query?.toLowerCase()) ||
                        items?.suppliername
                          ?.toLowerCase()
                          ?.includes(query?.toLowerCase()) ||
                        items?.projectCode
                          ?.toLowerCase()
                          ?.includes(query?.toLowerCase()) ||
                        items?.projectname
                          ?.toLowerCase()
                          ?.includes(query?.toLowerCase()),
                    )
                    ?.map((item, index) => {
                      return (
                        <tr key={`tbl-row-${index}`}>
                          <td>{item.ordercode}</td>
                          <td>{item.suppliername}</td>
                          <td>{item.projectCode}</td>
                          <td>{item.projectname}</td>
                          <td>
                            <Link
                              to={{
                                pathname: `/confirm-purchasing-order/${item.ordercode}`,
                                state: { orderid: item.orderid },
                              }}
                              className="d-flex align-items-center gap-3 redirect-link justify-content-center"
                            >
                              <img
                                className="plus-img"
                                src={PlusIcon}
                                alt="plus"
                              />
                              <div>{t("Add to warehouse")}</div>
                            </Link>
                          </td>
                        </tr>
                      );
                    })}
                  {!tableData?.filter(
                    (items) =>
                      items?.ordercode?.toLowerCase()?.includes(query) ||
                      items?.suppliername?.toLowerCase()?.includes(query) ||
                      items?.projectCode?.toLowerCase()?.includes(query) ||
                      items?.projectname?.toLowerCase()?.includes(query),
                  ).length > 0 && (
                    <tr style={{ height: "83%" }}>
                      <div
                        className="row container mt-5 pt-5 d-flex position-relative"
                        style={{ left: "27%" }}
                      >
                        <img
                          src={smallIcon}
                          alt="smali"
                          width={35}
                          height={35}
                          className="mt-5 "
                        />
                        <h6
                          className="mt-1"
                          style={{
                            fontSize: "14px",
                            fontWeight: 400,
                            textAlign: "center",
                            color: "#707070",
                          }}
                        >
                          {/* Sorry. */}
                          {t("Sorry")}.
                          <br />
                          {/* No results for your criteria. */}
                          {t("No results for your criteria.")}
                          <br />
                          {/* Try to refine your search or enter a new
                            search. */}
                          {t(
                            "Try to refine your search or enter a new search.",
                          )}
                        </h6>
                      </div>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          {tableData.length > 0 && (
            <div className="align-text-bottom stock-pagination">
              <Pagination
                perPage={perPage}
                setPerPage={setPerPage}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalPages={totalPages}
              />
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default AddToWareHouseProject;
